export const shortenLink = (
  url: string,
  length = 20,
  isRtl?: boolean
): string => {
  try {
    const urlObj = new URL(url);
    const domain = urlObj.hostname;
    const path =
      urlObj.pathname.length > length
        ? urlObj.pathname.slice(0, length)
        : urlObj.pathname;

    return isRtl ? `...${domain}${path}` : `${domain}${path}...`;
  } catch {
    const truncated = url.length > length ? url.slice(0, length) : url;
    return isRtl ? `...${truncated}` : `${truncated}...`;
  }
};
